import { data_store }   from './data-store';
import { country_code } from './../site-lang';

const cc    = country_code();
const store = data_store();

export default function record_content_download_form_sumbission(form) {
  if (!store) return false;

  const form_id = parseInt(form.getAttribute('data-form-id'));
  if (!form_id) return false;

  const content_download_forms = {
    en: [1441],
    de: [1045],
    es: [1044],
    fr: [1046],
  };

  const content_download_forms_current_site = content_download_forms[cc];
  const content_download_form_submitted     = content_download_forms_current_site.includes(form_id);

  if (!content_download_form_submitted) {
    return false;
  }

  store.set('ContentDownloadFormSubmitted', true);
}
